<div class="container-custom">
	<div class="table-header">
		<h2 class="title">{{ titulo }}</h2>
	</div>
  <ng-container
    *ngIf="
      !loading &&
      blDetails.operation_type_number === 4 &&
      overlayError === false
    "
  >
    <app-form-lote-cabotaje
      [blDetails]="blDetails"
      [clientesBl]="clientesBl"
      [idCliente]="idCliente"
    ></app-form-lote-cabotaje>
  </ng-container>
  <app-form-lote-cabotaje
    *ngIf="blDetails.operation_type_number === 3"
  ></app-form-lote-cabotaje>
</div>
<app-overlay
  *ngIf="loading"
></app-overlay>
<app-overlay
  *ngIf="overlayError"
  [reload]="true"
></app-overlay>
